module.exports = __webpack_public_path__ + "img/speaker-ShotaArveladze.28c88c66.png";